import { Injectable } from '@angular/core';

import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { Observable } from 'rxjs';
//import { UserService } from '../shared/user.service';
//import { ToastrService } from 'ngx-toastr';
import { LoginServiceService } from '../services/login-service.service';

@Injectable()
export class AuthGuard implements CanActivate {
  private index: number = 0;
  constructor(
    private router: Router,
    //private userService: UserService,
    //private toastr: ToastrService
    private loginService: LoginServiceService,    
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (localStorage.getItem('token') != null) {
      const destination: string = next.pathFromRoot[next.pathFromRoot.length - 1].url[0].toString();
      //console.log(destination);
      if(destination)
      {
        if(this.loginService.isTrHomePage(destination))
        {
          this.router.navigate(['/pages/trcheckin']);
        }
      }
      const roles = next.data['roles'] as Array<string>;
      //console.log(roles);
      if (roles) {
        const match = this.loginService.roleMatch(roles, destination);
        //console.log(match);
        if (match) {
          return true;
        } else {
          // tslint:disable-next-line: quotemark
          //this.toastr.info("You don't have access to this page");
          //this.showToast('top-right', 'info');
          this.router.navigate(['/auth/newlogin']);
          // this.router.navigate(['/forbidden']);
          return false;
        }
      } else {
        return true;
      }
      
    }
    //console.log('a1');
    this.router.navigate(['/auth/newlogin'], { queryParams: { returnUrl: state.url}});
    return false;
  }

  // showToast(position, status) {
  //   this.index += 1;
  //   this.toastrService.show(
  //     status || 'Success',
  //     `Toast ${this.index}`,
  //     { position, status });
  // }
}
